import { z } from "zod";
import { dmaCalculationRequestErrorSchema } from "./dma-calculation-request-error.schema";
export const dmaCalculationBadRequestResponseDtoSchema = z.object({
    errors: z.array(dmaCalculationRequestErrorSchema),
});
